export const getIdleState = (state) => state.idle.idle;
export const getStaleState = (state) => !state.idle.idle && state.idle.stale;
